import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const Upload = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.651 3.20046C11.8461 3.0061 12.1617 3.0061 12.3568 3.20046L15.5472 6.37874C15.7428 6.57363 15.7435 6.89022 15.5486 7.08585C15.3537 7.28148 15.0371 7.28209 14.8415 7.0872L12.5044 4.75908L12.5098 16.7412C12.5099 17.0173 12.2861 17.2413 12.01 17.2414C11.7338 17.2415 11.5099 17.0178 11.5098 16.7416L11.5044 4.75801L9.16636 7.0872C8.97072 7.28209 8.65414 7.28148 8.45925 7.08585C8.26436 6.89022 8.26496 6.57363 8.4606 6.37874L11.651 3.20046ZM3.5 13.5005C3.77614 13.5005 4 13.7244 4 14.0005L4 20.0005L20 20.0005V14.0005C20 13.7244 20.2239 13.5005 20.5 13.5005C20.7761 13.5005 21 13.7244 21 14.0005V20.5005C21 20.7767 20.7761 21.0005 20.5 21.0005L3.5 21.0005C3.22386 21.0005 3 20.7767 3 20.5005L3 14.0005C3 13.7244 3.22386 13.5005 3.5 13.5005Z"
			fill="#141414"
		/>
	</SvgIcon>
);
